import { create } from "zustand";

type ConfigStore = {
  shortFlowOn: boolean;
  setShortFlowOn(shortFlowOn: boolean): void;

  variantSpeedFlow: string[];
  setVariantSpeedFlow(variantSpeedFlow: string[]): void;

  setConfigValue: (key: string, value: unknown) => void;
};

export const useConfigStore = create<ConfigStore>((set) => ({
  shortFlowOn: false,
  setShortFlowOn(shortFlowOn) {
    set((store) => ({ ...store, shortFlowOn }));
  },

  variantSpeedFlow: ["off"],
  setVariantSpeedFlow(variantSpeedFlow) {
    set((store) => ({ ...store, variantSpeedFlow }));
  },

  setConfigValue(key, value) {
    set((store) => ({ ...store, [key]: value }));
  },
}));
